import React from 'react';
import BreadcrumbItem from "../../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../../component/Page/Page";
import CompanyForm from "../../component/Company/CompanyForm";

class CompanyFormPage extends React.Component {
  render() {
    const {match, history} = this.props;
    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Configurações"/>,
      <BreadcrumbItem key={2} title="Lista de empresas" to="/list/companies"/>,
      <BreadcrumbItem key={3} title="Dados da empresa" active={true}/>
    ];
    return (
        <Page title="Dados da Empresa" breadcrumbs={breadcrumbs}>
          <CompanyForm match={match} history={history}/>
        </Page>
    );
  }
}

export default CompanyFormPage;


// WEBPACK FOOTER //
// ./src/pages/Company/CompanyFormPage.js